// src/index.js
import React from 'react';  
import ReactDOM from 'react-dom/client';  
import './index.css';  
import './tailwind.css'; 
import AppWithRoutes from './AppWithRoutes';  
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { BusinessProvider } from './contexts/BusinessContext';

// Add this near the top of src/index.js to catch unhandled promise rejections
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Improved ErrorBoundary with styling matching your app's design
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Error:", error, errorInfo);
    this.setState({ error, errorInfo });
    
    // Optional: Send error to monitoring service
    // logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-sws-light-cream flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
            <h2 className="text-xl font-bold text-sws-navy mb-4">Something went wrong</h2>
            <p className="text-sws-slate mb-4">We apologize for the inconvenience. Please try refreshing the page or contact support if the problem persists.</p>
            <button 
              onClick={() => window.location.reload()} 
              className="px-4 py-2 bg-sws-navy text-white rounded-lg hover:bg-sws-slate transition-colors"
            >
              Refresh Page
            </button>
            
            {/* Show technical details in development environment */}
            {process.env.NODE_ENV !== 'production' && (
              <details className="mt-4 border-t pt-4 text-sws-slate">
                <summary className="cursor-pointer font-medium">Error details (development only)</summary>
                <p className="mt-2 text-red-600 text-sm">{this.state.error && this.state.error.toString()}</p>
                <pre className="mt-2 bg-gray-100 p-2 rounded text-xs overflow-auto max-h-64">
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BusinessProvider>
          <AppWithRoutes />
        </BusinessProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();